import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kategooriat ei leitud

  <span style="color:#85c1dc;">**FI:**</span>
  Kategoriaa ei löytynyt

  <span style="color:#85c1dc;">**RU:**</span>
  Категория не найдена
*/
/* @__NO_SIDE_EFFECTS__ */
const m315 = msg(
  mf`Kategooriat ei leitud`,
  mf`Kategoriaa ei löytynyt`,
  mf`Категория не найдена`,
)

export { m315 as 'w.module.categories_search.no_categories_title' }